import { useEffect } from 'react';
import { getDefaultAnalyticsTraits } from '../helpers/analytics';

/**
 * Hook to track an event when a component mounts on the client-side.
 * @param {string} eventName - The name of the event to track.
 * @param {object} properties - Additional properties for the RudderStack event.
 */
const useTrackComponentMount = (eventName: string, properties = {}) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.rudderanalytics) {
      try {
        window.rudderanalytics.track(eventName, {
          ...getDefaultAnalyticsTraits(),
          ...properties,
        });
      } catch (error) {
        console.error('RudderStack track failed:', error);
      }
    } else if (typeof window !== 'undefined') {
      console.warn(`RudderStack analytics not available when trying to track event: ${eventName}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useTrackComponentMount;
